import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './NotFound.module.scss';

export const NotFound: React.FC = () => {
  const { t } = useTranslation('header');

  return (
    <main className={styles.main}>
      <p className={styles.code}>404</p>
      <h1>{t('notFoundTitle')}</h1>
      <p>{t('notFoundMessage')}</p>
      <a href="/">{t('backHome')}</a>
    </main>
  );
};
